import React, {FC, useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {IBlogsLocale} from "../../types/pages";
import {IState} from "../../types/state";
import cls from "./blog.module.scss"
import BlogPost from "./BlogPost";
import PageHeader from "../shared/PageHeader";

interface IProps {
    blog: Array<IBlogsLocale>,
    blogSlug?: string | Array<string>,
    dbName: string,
    domain: string,
    layout?: string,
    locale: string,
    sidebarPosition?: string,
    forBLogType: string,
    breadcrumb: Array<{ title: string; url: string }>;
}

const BlogPagePost: FC<IProps> = ({
                                      forBLogType,
                                      breadcrumb,
                                      layout,
                                      blogSlug,
                                      blog: propsBlog,
                                      locale,
                                      domain
                                  }) => {
    let content;
    let blogOne;
    const [blog, setBlog] = useState<IBlogsLocale>(propsBlog[0]);
    const [redirect, _] = useState();
    const dbName = useSelector((state: IState) => state.general.dbName)

    const prevBlogSlugRef: { current?: string | Array<string> } = useRef()
    const prevLocaleCodeRef: { current?: string | Array<string> } = useRef();

    useEffect(() => {
        prevBlogSlugRef.current = blogSlug;
        prevLocaleCodeRef.current = locale;
    }, []);

    useEffect(() => {
        if (
            prevBlogSlugRef.current !== blogSlug ||
            prevLocaleCodeRef.current !== locale
        ) {
            setBlog(propsBlog[0]);
            prevBlogSlugRef.current = blogSlug;
            prevLocaleCodeRef.current = locale;
        }
    }, [blogSlug, locale]);

    if (redirect) {
        ///  return router.push("/404");
    }

    if (blog) {
        blogOne = blog;
    }

    content = (
        <div className={`row ${cls.blog_container}`}>
            <BlogPost
                forBLogType={forBLogType}
                blog={blogOne}
                dbName={dbName}
                layout={layout}
                domain={domain}
            />
        </div>
    );

    return (
        <div className="page">
            <PageHeader dbName={dbName} breadcrumb={breadcrumb}/>
            <div className="container">{content}</div>
        </div>
    );
}

export default BlogPagePost